import * as Mutations from './mutations';
import * as AccountExceptions from '@/components/no-auth/account-exceptions';
import * as Routes from '@/router/routes';
import { SignUpService } from '@/common/services/sign-up.service';
import { removeSpaces } from '@/common/utils/strings';
import router from '@/router';

const StepsCount = 3;

export const RegistrationModule = {
    state: {
        registrationForm: {},
        username: ''
    },

    mutations: {
        [Mutations.ADD_TO_FORM] (state, form) {
            state.registrationForm = {
                ...state.registrationForm,
                ...form
            };
        },

        [Mutations.RESET_FORM] (state) {
            state.registrationForm = [];
        },

        [Mutations.SAVE_USERNAME] (state, username) {
            state.username = username;
        }
    },

    actions: {
        async submitStep(context, payload) {
            context.commit(Mutations.ADD_TO_FORM, payload.form);
            if (payload.step >= StepsCount) {
                const form = context.getters.registrationForm;
                form.phone = removeSpaces(form.phone);
                if (form.tagLine === '') {
                    delete form.tagLine;
                }
                try {
                    context.dispatch('showSpinner');
                    await SignUpService.signUp(form);
                    context.dispatch('saveUsername', form.email);
                    router.push({
                        name: Routes.REGISTRATION_CONFIRM,
                        query: { exception: AccountExceptions.UNVERIFIED_EMAIL }
                    });
                }
                catch (e) {
                    throw e;
                }
                finally {
                    context.dispatch('hideSpinner');
                }
            }
        },

        saveUsername(context, username) {
            context.commit(Mutations.SAVE_USERNAME, username);
            sessionStorage.setItem('email', username);
        }
    },

    getters: {
        registrationForm: state => state.registrationForm,

        username: state => state.username
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/registration/registration.module.js